// IMPORT PACKAGE REFERENCES

import React, {Fragment} from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import firebase from '../../Config/Firebase';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { logout } from '../State/Actions/UserActions';
import logoLight from '../../Images/logo-light.png';
import dashboardLight from '../../Images/dashboard-light.png';
import pharmacyLight from '../../Images/pharmacy-light.png';
import devicesLight from '../../Images/devices-light.png';

// COMPONENT

class Header extends React.Component {

    constructor(props) {
        super(props);
        this.handleLogout = this.handleLogout.bind(this);
    }

    handleLogout(event) {
        event.preventDefault(); 

        this.props.logout();
    }

    render() {
        let currentLocation = this.props.location.pathname;

        return (
            <Fragment>
            <nav className="navbar navbar-expand-lg navbar-light alert-dark">
                    <div className="container">          
                        <a className="navbar-brand" href="/">
                            <img className="logo" src={logoLight}></img>
                        </a>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#menu">
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        { this.props.loggedIn &&
                        <div className="collapse navbar-collapse" id="menu">
                            <ul className="navbar-nav mr-auto">
                                <li className="nav-item">
                                    <div className={"nav-link " + (currentLocation === '/' ? "active" : "")}>
                                        <img className="nav-icon" src={dashboardLight}></img>
                                        <NavLink to='/' className="menu-item" activeClassName='menu selected' exact={true}>Dashboard</NavLink>
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <div className={"nav-link " + (currentLocation.includes('/pharmac') ? "active" : "")}>
                                        <img className="nav-icon" src={pharmacyLight}></img>
                                        <NavLink to='/pharmacies'  className="menu-item" activeClassName='menu selected'>Pharmacies</NavLink>
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <div className={"nav-link " + (currentLocation.includes('/device') ? "active" : "")}>
                                        <img className="nav-icon" src={devicesLight}></img>
                                        <NavLink to='/devices' className="menu-item" activeClassName='menu selected'>Devices</NavLink>
                                    </div>
                                </li>
                                {/* <li className="nav-item">
                                    <div className="nav-link">
                                        <img className="nav-icon" src="/Images/settings-light.png"></img>
                                        <NavLink to='/about' className="menu-item" activeClassName='menu selected'>Settings</NavLink>
                                    </div>
                                </li> */}
                            </ul>
                            <div className="logout-button" onClick={this.handleLogout}>Logout</div>
                        </div>
                        }

                        
                    </div>
                </nav>
            </Fragment>
        )
    }
    
}

Header.propTypes = {
    history: PropTypes.object.isRequired
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { loggedIn } = state.userReducer;
    return { loggedIn };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ logout }, dispatch)
);

const hoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));

// EXPORT COMPONENT

export { hoc as Header };

